module.exports = __webpack_public_path__ + "img/7-icono-mis-ordenes-selected.b976e13d.svg";